import React from 'react';
import Icon from 'common/icon/Icon';
import Card from 'common/card/Card';

const CONTENT = [
    {
        title: 'Look',
        icon: 'search',
        description: 'Find and compare pricing on convenient parking spots near your destination',
    },
    {
        title: 'Book',
        icon: 'check-circle',
        description: 'Prepay for your spot and get a parking pass instantly via text, email, or the app'
    },
    {
        title: 'Park',
        icon: 'amenity-mobile',
        description: "Scan or show your mobile parking pass when you arrive, and you're all set!",
    }
];

const LookBookPark = () => (
    <Card className="LookBookPark">
        <ul className="LookBookPark-list">
            {
                CONTENT.map(({
                    description,
                    icon,
                    title,
                }) => (
                    <li
                        className="LookBookPark-item"
                        key={title}
                    >
                        <div className="LookBookPark-icon">
                            <Icon name={icon} />
                        </div>
                        <div className="LookBookPark-content">
                            <h1 className="LookBookPark-title">{title}</h1>
                            <p className="LookBookPark-description">{description}</p>
                        </div>
                    </li>
                ))
            }
        </ul>
    </Card>
);

export default LookBookPark;
